import { createCSSTheme, createTheme } from "./utils"

export const { theme, vars, literals } = createTheme({
  borderRadius: {
    literals: {
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      6: "6px",
      8: "8px",
      10: "10px",
      12: "12px",
      "50%": "50%",
      "100%": "100%",
      inherit: "inherit"
    }
  },
  borderStyle: {
    literals: {
      none: "none",
      dashed: "dashed",
      solid: "solid"
    }
  },
  borderWidth: {
    literals: {
      0: "0px",
      1: "1px",
      2: "2px",
      3: "3px"
    }
  },
  boxShadow: {
    literals: { none: "none" },
    varPrefix: "box-shadow",
    vars: {
      "-1": "0px 1px 0px 0px hsla(0, 0%, 0%, 0.08) inset",
      "1": "0px 1px 0px 0px hsla(0, 0%, 0%, 0.04)",
      "2": "0px 2px 1px 0px hsla(0, 0%, 0%, 0.05)",
      "3": "0px 2px 10px 0px hsla(0, 0%, 0%, 0.1)",
      "4": "0px 26px 80px 0px hsla(0, 0%, 0%, 0.2)",
      purpleFocus: "0px 0px 0px 2px hsla(251, 63%, 63%, 0.3)",
      ghostFocus: "0px 0px 0px 3px hsla(247, 4%, 45%, 0.3)",
      greenFocus: "0px 0px 0px 2px hsla(151, 55%, 42%, 0.3)",
      amberFocus: "0px 0px 0px 2px hsla(38, 100%, 57%, 0.3)",
      tomatoFocus: "0px 0px 0px 2px hsla(10, 78%, 54%, 0.3)",
      gradient: {
        light: "0px 0px 10px 10px hsl(300, 8%, 97%)",
        dark: "0px 0px 10px 10px hsl(240, 5%, 12%)"
      },
      greyFocus: "0px 0px 0px 2px hsla(300, 8%, 95%, 0.3)",
      cropper: "0 0 0 9999em"
    }
  },
  color: {
    literals: {
      currentColor: "currentColor",
      transparent: "transparent",
      inherit: "inherit",
      white: "white",
      black: "black"
    },
    vars: {
      grey1: { light: "hsl(300, 0%, 100%)", dark: "hsl(240, 4%, 9%)" },
      grey2: { light: "hsl(300, 8%, 97%)", dark: "hsl(240, 5%, 12%)" },
      grey3: { light: "hsl(300, 8%, 95%)", dark: "hsl(240, 4%, 14%)" },
      grey4: { light: "hsl(270, 6%, 93%)", dark: "hsl(240, 5%, 16%)" },
      grey5: { light: "hsl(270, 5%, 91%)", dark: "hsl(240, 4%, 19%)" },
      grey6: { light: "hsl(300, 4%, 89%)", dark: "hsl(240, 5%, 22%)" },
      grey7: { light: "hsl(270, 3%, 86%)", dark: "hsl(240, 5%, 25%)" },
      grey8: { light: "hsl(255, 4%, 79%)", dark: "hsl(248, 5%, 33%)" },
      grey9: { light: "hsl(255, 4%, 57%)", dark: "hsl(247, 4%, 45%)" },
      grey10: { light: "hsl(253, 4%, 54%)", dark: "hsl(247, 4%, 51%)" },
      grey11: { light: "hsl(247, 4%, 45%)", dark: "hsl(249, 4%, 64%)" },
      grey12: { light: "hsl(261, 25%, 11%)", dark: "hsl(240, 6%, 93%)" },

      dark12: { light: "hsl(240, 6%, 93%)", dark: "hsl(240, 6%, 93%)" },

      indigo2: { light: "hsl(223, 100%, 99%)", dark: "hsl(230, 36%, 13%)" },
      indigo4: { light: "hsl(223, 92%, 95%)", dark: "hsl(227, 48%, 21%)" },
      indigo7: { light: "hsl(225, 78%, 82%)", dark: "hsl(226, 56%, 35%)" },
      indigo10: { light: "hsl(226, 59%, 51%)", dark: "hsl(227, 76%, 62%)" },
      indigo11: { light: "hsl(226, 55%, 45%)", dark: "hsl(228, 100%, 76%)" },
      indigo12: { light: "hsl(226, 63%, 17%)", dark: "hsl(228, 79%, 96%)" },

      green3: { light: "hsl(139, 57%, 95%)", dark: "hsl(155, 46%, 11%)" },
      green4: { light: "hsl(139, 48%, 91%)", dark: "hsl(154, 48%, 13%)" },
      green9: { light: "hsl(151, 55%, 42%)", dark: "hsl(151, 55%, 42%)" },
      green10: { light: "hsl(152, 57%, 38%)", dark: "hsl(151, 49%, 46%)" },
      green11: { light: "hsl(153, 67%, 28%)", dark: "hsl(151, 50%, 53%)" },
      green12: { light: "hsl(155, 41%, 14%)", dark: "hsla(136, 73%, 94%, 1)" },

      amber3: { light: "hsl(44, 100%, 92%)", dark: "hsl(32, 100%, 10%)" },
      amber4: { light: "hsl(43, 100%, 87%)", dark: "hsl(32, 100%, 12%)" },
      amber9: { light: "hsl(39, 100%, 57%)", dark: "hsl(39, 100%, 57%)" },
      amber10: { light: "hsl(35, 100%, 55%)", dark: "hsl(43, 100%, 64%)" },
      amber11: { light: "hsl(30, 100%, 34%)", dark: "hsl(39, 90%, 50%)" },
      amber12: { light: "hsl(20, 79%, 17%)", dark: "hsl(40, 94%, 93%, )" },

      tomato1: { light: "hsl(0, 100%, 99%)", dark: "hsl(11, 23%, 9%)" },
      tomato2: { light: "hsl(8, 100%, 98%)", dark: "hsl(9, 45%, 11%)" },
      tomato3: { light: "hsl(7, 100%, 97%)", dark: "hsl(7, 51%, 15%)" },
      tomato4: { light: "hsl(8, 100%, 94%)", dark: "hsl(7, 57%, 18%)" },
      tomato6: { light: "hsl(9, 86%, 86%)", dark: "hsl(8, 64%, 24%)" },
      tomato7: { light: "hsl(10, 77%, 79%)", dark: "hsl(8, 72%, 29%)" },
      tomato9: { light: "hsl(10, 78%, 54%)", dark: "hsl(10, 78%, 54%)" },
      tomato10: { light: "hsl(10, 72%, 50%)", dark: "hsl(10, 82%, 59%)" },
      tomato11: { light: "hsl(10, 82%, 44%)", dark: "hsl(10, 85%, 63%)" },
      tomato12: { light: "hsl(10, 51%, 14%)", dark: "hsl(10, 90%, 96%)" },

      purple1: { light: "hsl(270, 50%, 99%)", dark: "hsl(252, 19%, 10%)" },
      purple2: { light: "hsl(252, 100%, 99%)", dark: "hsl(255, 30%, 13%)" },
      purple3: { light: "hsl(254, 100%, 97%)", dark: "hsl(252, 36%, 18%)" },
      purple4: { light: "hsl(251, 91%, 95%)", dark: "hsl(253, 40%, 22%)" },
      purple5: { light: "hsl(252, 83%, 93%)", dark: "hsl(252, 42%, 26%)" },
      purple6: { light: "hsl(251, 78%, 89%)", dark: "hsl(251, 44%, 31%)" },
      purple7: { light: "hsl(252, 71%, 84%)", dark: "hsl(250, 47%, 39%)" },
      purple8: { light: "hsl(252, 69%, 76%)", dark: "hsl(250, 52%, 51%)" },
      purple9: { light: "hsl(252, 56%, 57%)", dark: "hsl(252, 56%, 57%)" },
      purple10: { light: "hsl(251, 48%, 53%)", dark: "hsl(251, 63%, 63%)" },
      purple11: { light: "hsl(250, 43%, 48%)", dark: "hsl(250, 95%, 77%)" },
      purple12: { light: "hsl(254, 60%, 18%)", dark: "hsl(251, 89%, 96%)" },

      greyAlpha1: {
        light: "hsla(0, 0%, 0%, 0.3)",
        dark: "hsla(0, 0%, 0%, 0.3)"
      }
    }
  },
  cursor: {
    literals: {
      default: "default",
      move: "move",
      pointer: "pointer",
      text: "text",
      grab: "grab",
      notAllowed: "not-allowed",
      initial: "initial"
    }
  },
  fontFamily: {
    literals: { inherit: "inherit" },
    varPrefix: "font-family",
    vars: {
      body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      code: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace"
    }
  },
  gradient: {
    varPrefix: "gradient",
    vars: {
      "checker-board": {
        dark: "repeating-conic-gradient(hsl(248, 5%, 33%) 0% 25%, hsl(240, 5%, 12%) 0% 50%) 50% / 10px 10px",
        light:
          "repeating-conic-gradient(hsl(255, 4%, 79%) 0% 25%, hsl(300, 8%, 97%) 0% 50%) 50% / 10px 10px"
      }
    }
  },
  opacity: {
    literals: {
      0: "0",
      0.1: "0.1",
      0.3: "0.3",
      0.4: "0.4",
      0.5: "0.5",
      0.6: "0.6",
      0.8: "0.8",
      0.9: "0.9",
      1: "1"
    }
  },
  size: {
    varPrefix: "size",
    vars: {
      small: "28px", // The height of a small Button in the DS.
      medium: "32px", // The height of a medium Button in the DS.
      large: "40px", // The height of a large Button in the DS.
      scrollbar: "12px" // The height of the custom scrollbar
    }
  },
  space: {
    literals: {
      auto: "auto",
      0: "0px",
      1: "1px",
      2: "2px",
      4: "4px",
      6: "6px",
      8: "8px",
      10: "10px",
      12: "12px",
      16: "16px",
      18: "18px",
      20: "20px",
      24: "24px",
      28: "28px",
      32: "32px",
      40: "40px",
      48: "48px",
      72: "72px",
      80: "80px",
      100: "100px"
    },
    varPrefix: "space",
    vars: {
      fieldSetGap: "16px" // The gap in the FieldSet component
    }
  },
  transitionDuration: {
    literals: {
      0: "0ms",
      75: "75ms",
      100: "100ms",
      150: "150ms",
      200: "200ms",
      250: "250ms",
      300: "300ms",
      400: "400ms"
    }
  },
  zIndex: {
    // Forbid using z-indexes.
    literals: {}
  }
})

type Theme = typeof theme

// Ensures we keep a typesafe, documented link between components and theme.
export type ThemeKeys<
  Name extends keyof Theme,
  Keys extends keyof Theme[Name] = keyof Theme[Name]
> = Keys

// CSS theme (i.e which values are valid inside CSS files)
// This is used in the Stylelint config file to ensure only valid theme values are used.
export const cssTheme = createCSSTheme(vars, literals, {
  borderRadius: [
    "border-radius",
    "border-bottom-right-radius",
    "border-bottom-left-radius",
    "border-top-right-radius",
    "border-top-left-radius"
  ],
  borderStyle: [
    "border-style",
    "border-top-style",
    "border-bottom-style",
    "border-right-style",
    "border-left-style",
    "outline-style"
  ],
  borderWidth: [
    "border-width",
    "border-bottom-width",
    "border-right-width",
    "outline-width"
  ],
  boxShadow: ["box-shadow"],
  cursor: ["cursor"],
  color: [
    "background",
    "background-color",
    "fill",
    "border-color",
    "border-top-color",
    "border-bottom-color",
    "border-right-color",
    "color",
    "stroke",
    "outline-color"
  ],
  fontFamily: ["font-family"],
  gradient: ["background"],
  opacity: ["opacity"],
  size: [],
  space: [
    "gap",
    "margin",
    "margin-block",
    "margin-top",
    "margin-bottom",
    "margin-inline",
    "margin-left",
    "margin-right",
    "padding",
    "padding-block",
    "padding-top",
    "padding-bottom",
    "padding-inline",
    "padding-left",
    "padding-right"
  ],
  transitionDuration: ["transition-duration", "animation-duration"],
  zIndex: ["z-index"]
})
